<template>
  <div class="cul">
    <div class="top">
      <img class="line" src="../../assets/index/line.png" alt="" />
      <div class="title">产品性能</div>
    </div>
    <div class="banner">
      <img :src="`${imgurl}`" alt="" />
    </div>
    <!-- 背景图 -->
    <!-- :style="active == index ? item._image : item.bg_image" -->

    <div
      :style="
        active == index
          ? {
              'background-image': `url(${item.bg_image})`,
            }
          : null
      "
      class="pic"
      v-for="(item, index) in list"
      :key="index"
      @mouseover="handleMouse(index)"
    >
      <div class="yj">
        <div class="icon">
          <img :src="active == index ? item.hover_image : item.image" alt="" />
          <span :style="{ color: active == index ? '#ffffff' : '#6C7A77' }">{{
            item.title
          }}</span>
        </div>
        <div>
          <div
            class="title"
            :style="{ color: active == index ? '#ffffff' : '#004C31' }"
          >
            {{ item.title_en }}
          </div>
          <div
            :style="{ color: active == index ? '#ffffff' : '#6C7A77' }"
            class="desc"
          >
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { performance } from "../../api/request";

export default {
  name: "Culture",
  data() {
    return {
      imgurl: null,
      active: 0,
      list: [
        // {
        //   id: 0,
        //   name: "保温",
        //   bg: {
        //     backgroundImage:
        //       "url(" + require("../../assets/performance/1.png") + ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center center",
        //     backgroundCover: "cover",
        //   },
        //   img: require("../../assets/performance/1.png"),
        //   icon: require("../../assets/performance/1g.png"),
        //   activeIcon: require("../../assets/performance/1b.png"),
        //   title: "Keep warm",
        //   desc: "阁韵铝包木门窗采用三玻两腔中空Low-E玻璃，四道密封处理，且中空玻璃内充入氩气。氩气作为惰性气体，其自身具有的特性可以减慢中空玻璃内的热对流，冬天能够将热能保留在室内。并且加入吸收水分的分子筛，杜绝水雾的产生，提高节能效果。",
        // },
        // {
        //   id: 0,
        //   name: "降噪",
        //   bg: {
        //     backgroundImage:
        //       "url(" + require("../../assets/performance/2.png") + ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center center",
        //     backgroundCover: "cover",
        //   },
        //   img: require("../../assets/performance/2.png"),
        //   icon: require("../../assets/performance/2g.png"),
        //   activeIcon: require("../../assets/performance/2b.png"),
        //   title: "Noise reduction",
        //   desc: "阁韵铝包木窗承重主体木材是由木纤维构成，内部分布导管，木材本身的分子密度小，构造特性不利于声音的传播，是天然的隔音墙。其次阁韵标准配置的玻璃采用三玻内充氩气，三层钢化玻璃隔音，内部充氩气能改变声波传播介质，保证有效隔音性。除此之外，我们整窗开启与固定之间有四道密封，采用汽车级密封胶条，具有优异的隔音降噪性。",
        // },
        // {
        //   id: 0,
        //   name: "防风",
        //   bg: {
        //     backgroundImage:
        //       "url(" + require("../../assets/performance/3.png") + ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center center",
        //     backgroundCover: "cover",
        //   },
        //   img: require("../../assets/performance/3.png"),
        //   icon: require("../../assets/performance/3g.png"),
        //   activeIcon: require("../../assets/performance/3b.png"),
        //   title: "Windproof",
        //   desc: "阁韵铝包木窗外铝内木，在主体木材的外部又多加了一层铠甲，使得铝包木门窗在面对强风袭击的时候，又多了一道安全防线。且阁韵铝包木门窗采用进口五金，将门窗的框与扇紧密连接起来，四道密封处理，每一道环节运用的主材都选用顶级的标准严格把控，加工精度高，使得整窗具有出色的密封性能，杜绝风沙从缝隙渗透进室内。",
        // },
        // {
        //   id: 0,
        //   name: "防火",
        //   bg: {
        //     backgroundImage:
        //       "url(" + require("../../assets/performance/4.png") + ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center center",
        //     backgroundCover: "cover",
        //   },
        //   img: require("../../assets/performance/4.png"),
        //   icon: require("../../assets/performance/4g.png"),
        //   activeIcon: require("../../assets/performance/4b.png"),
        //   title: "Fire prevention",
        //   desc: "绝对防火的建筑是不存在的，因此，建材的安全设计目标由“防火”日益转变为“耐火”。阁韵木窗的主要原材料是优质集成木材，并经过严格筛选，以及防腐、脱脂、阻燃等处理，木材的燃点为250℃，且在燃烧时木材会碳化，这样使得里面的木头形成一个保护膜，也叫碳化层，从而抑制它的燃烧。所以铝包木窗在火灾中能够保存完整，起到防火减灾的作用，为逃生赢得出口。",
        // },
        // {
        //   id: 0,
        //   name: "防盗",
        //   bg: {
        //     backgroundImage:
        //       "url(" + require("../../assets/performance/5.png") + ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center center",
        //     backgroundCover: "cover",
        //   },
        //   img: require("../../assets/performance/5.png"),
        //   icon: require("../../assets/performance/5g.png"),
        //   activeIcon: require("../../assets/performance/5b.png"),
        //   title: "Anti-theft",
        //   desc: "阁韵铝包木窗所采用的五金全部为顶级原装进口五金，蘑菇头锁点＋多锁点防盗设计达到欧洲WK2防盗标准，表层采用六价铬镀层，亮度好、安全耐用，使我们的人身财产安全得到保证，杜绝安全隐患。",
        // },
        // {
        //   id: 0,
        //   name: "防水",
        //   bg: {
        //     backgroundImage:
        //       "url(" + require("../../assets/performance/6.png") + ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center center",
        //     backgroundCover: "cover",
        //   },
        //   img: require("../../assets/performance/6.png"),
        //   icon: require("../../assets/performance/6g.png"),
        //   activeIcon: require("../../assets/performance/6b.png"),
        //   title: "Water proof",
        //   desc: "阁韵铝包木窗采用优质密封胶条，在窗扇与窗框之间以及玻璃与窗扇之间采用抗老化、弹性好的密封胶条，其材质达到国家标准规定的物理性能指标。门窗关闭之时，胶条能很好地压在窗框上，密封性较强；外铝部分还采用了先进的无缝焊接技术，完美解决铝材45°组角部位出现的透气漏水和不美观问题，其立面隐藏式排水设计，也完美的解决了大雨积水，风压过大排不出的现象，以此减少雨水渗透的可能。",
        // },
        // {
        //   id: 0,
        //   name: "美观",
        //   bg: {
        //     backgroundImage:
        //       "url(" + require("../../assets/performance/7.png") + ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center center",
        //     backgroundCover: "cover",
        //   },
        //   img: require("../../assets/performance/7.png"),
        //   icon: require("../../assets/performance/7g.png"),
        //   activeIcon: require("../../assets/performance/7b.png"),
        //   title: "Beautiful",
        //   desc: "阁韵铝包木窗内柔外刚，室内侧木材色泽天然，保持了木材原有的天然本色，有独一无二的纹理、线条饱满流畅、温和亲切，与室内的实木家具相得益彰，尽现良好质感！室外在保留纯实木门窗特性和功能的前提下，通过特殊工艺在窗外侧镶嵌一层铝合金型材，其表面可以喷涂各种颜色，与建筑外观又可视觉协调统一，可以达到双重装饰的效果。",
        // },
        // {
        //   id: 0,
        //   name: "环保",
        //   bg: {
        //     backgroundImage:
        //       "url(" + require("../../assets/performance/8.png") + ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center center",
        //     backgroundCover: "cover",
        //   },
        //   img: require("../../assets/performance/8.png"),
        //   icon: require("../../assets/performance/8g.png"),
        //   activeIcon: require("../../assets/performance/8b.png"),
        //   title: "Environmental friendly",
        //   desc: "阁韵铝包木窗的承重主体是木材，是自然的生命体，是可循环再生的资源。木材的合理开采也可以避免一些年老枯朽的木材发生火灾或是腐烂，是最好的固碳过程。其木材表面喷涂的水性漆采用的是进口水性漆，以水为溶剂，无毒无味、具有开放性，保持了木材天然的活性与环保性，让漆膜对木材产生更持久的保护。所以，铝包木窗是符合可持续发展的理念，具有环保性！",
        // },
      ],
    };
  },
  mounted() {
    performance().then((res) => {
      if (res.data.code == 1) {
        console.log(res.data.data);
        this.list = res.data.data.data;
        this.imgurl = res.data.data.banner;
      }
    });
  },
  methods: {
    handleMouse(index) {
      this.active = index;
    },
  },
};
</script>

<style scoped lang="less">
.cul {
  font-family: 微软雅黑, MicrosoftYaHei;
  .top {
    text-align: left;
    margin-left: 320px;
    background: #ffffff;
    width: 100%;
    padding: 59px 0;
    .line {
    }
    .title {
      font-size: 42px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 24px;
    }
  }
  .banner {
    width: 100%;
    height: 1100px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .pic {
    background-size: "cover";
    background-position: "center center";
    background-size: cover;

    width: 100%;
    height: 351px;
    .yj {
      display: flex;
      align-items: flex-start;
      .icon {
        margin: 86px 180px 0 352px;
        width: 105px;
        height: 105px;
        color: #6c7a77;
        img {
          width: 105px;
          height: 105px;
        }
      }
      .title {
        margin-top: 86px;
        text-align: justify;
        font-size: 24px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
        line-height: 42px;
      }
      .desc {
        margin-top: 32px;
        text-align: justify;
        width: 960px;
        font-size: 20px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #6c7a77;
        line-height: 36px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .cul {
    font-family: 微软雅黑, MicrosoftYaHei;
    .top {
      text-align: left;
      margin-left: 320px;
      background: #ffffff;
      width: 100%;
      padding: 59px 0;
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 24 * 2px;
      }
    }
    .banner {
      width: 100%;
      height: 1100px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .pic {
      width: auto;
      height: auto;
      .yj {
        display: flex;
        align-items: flex-start;
        .icon {
          margin: 86px 180px 0 352px;
          width: 105 * 2px;
          font-size: 48px;
          height: 105 * 2px;
          color: #6c7a77;
          img {
            width: 105 * 2px;
            height: 105 * 2px;
          }
        }
        .title {
          margin-top: 86px;
          text-align: justify;
          font-size: 24 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #004c31;
          line-height: unset;
        }
        .desc {
          margin-top: 32 * 2px;
          text-align: justify;
          width: 1060px;
          font-size: 20 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #6c7a77;
          line-height: unset;
        }
      }
    }
  }
}
</style>
